export const AUTOCOMPLETE_MARGIN = 6
